/* 🤖 this file was generated by svg-to-ts */
export const matIconSkipPrevious: {
  name: 'skip-previous';
  data: string;
} = {
  name: 'skip-previous',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M6 6h2v12H6zm3.5 6 8.5 6V6l-8.5 6zm6.5 2.14L12.97 12 16 9.86v4.28z"/></svg>`
};
